import getGladlyToken from 'services/api/gladChat/getGladlyToken';
import postHandoffSummary from 'services/api/gladChat/postHandoffSummary';

export default { getGladlyToken, postHandoffSummary };
